module.exports = __webpack_public_path__ + "static/media/deposit.95a87de3.png";